<template>
    <div class="container page-router-component">
        <router-view style="width: 100%;"></router-view>
    </div>
</template>

<script>

export default {
    name: "PageRouter",
}
</script>

<style scoped>
.container {
    margin-top: 8px;
    display:flex;
}
</style>